var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      staticClass: "custom-modal",
      attrs: { title: "黑名单", width: "800" },
      model: {
        value: _vm.blackUserListShow,
        callback: function ($$v) {
          _vm.blackUserListShow = $$v
        },
        expression: "blackUserListShow",
      },
    },
    [
      _c(
        "Row",
        { attrs: { gutter: 24 } },
        [
          _c("pagination-table", {
            staticClass: "custom-table",
            attrs: {
              columns: _vm.blackUserTable.columns,
              data: _vm.blackUserTable.data,
              loading: _vm.blackUserTable.loading,
              "table-search": _vm.blackUserTable.tableSearch,
              "table-load-event": _vm.getBlackUserList,
              autoHeight: true,
              showPage: false,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }